import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
export function AuthorQuote() {
  return <section className="py-12 px-6 bg-cream" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="border-l-4 border-terracotta pl-6 space-y-4" data-id="element-27">
          <Flame className="w-6 h-6 text-gold" aria-hidden="true" data-id="element-28" />
          <p className="text-xl md:text-2xl font-serif italic text-navy/90 leading-relaxed" data-id="element-29">
            "Este libro no nació de la teoría. Nació de conocer ese cansancio
            desde adentro — las decisiones solas, las noches sin dormir, y la
            culpa de necesitar un descanso."
          </p>
          <p className="text-base text-navy/60 font-medium" data-id="element-30">
            — El equipo de Cuidador de Padres
          </p>
        </motion.div>
      </div>
    </section>;
}